/* eslint-disable */
import React, { Component } from 'react'
import { StackNavigator } from 'react-navigation';
import { ScrollView, View, Text, TextInput, Button, Alert, KeyboardAvoidingView, Keyboard, Animated, TouchableOpacity, TouchableWithoutFeedback, Dimensions, StatusBar } from 'react-native'
import { connect } from 'react-redux'

import ProfilePhoto from '../Components/ProfilePhoto'
import ProfilePhotoCell from '../Components/ProfilePhotoCell'
import InputCell from '../Components/InputCell'
import FooterButton from '../Components/FooterButton'
import NavigationBar from '../Components/NavigationBar'
import { Images } from '../Themes'
import { KeyboardAwareScrollView, isIPhoneX } from '../Lib/utils'
import BadgeButton from '../Components/BadgeButton'
import { validateChangePassword } from '../Components/ValidateComponent'
import AuthActions from '../Redux/AuthRedux'
import { Field, reduxForm, startSubmit } from 'redux-form'
import { SvgBackButton } from '../Components/SvgComponent/';
import styles from './Styles/LoginScreenStyle'
import { Fonts } from   '../Themes'
import BaseScreen from './BaseScreen'
import I18n from "i18n-js"

let { width: screenWidth, height: screenHeight } = Dimensions.get('window')
const isIPhoneSE = (screenWidth === 320.0)

class ChangePasswordScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      oneTimeCode: this.props.oneTimeCode,
      password: '',
      confirmPassword: '',
      startTime: (new Date()).getTime()
    }
    console.log('ChangePasswordScreen constructor oneTimeCode: ' + JSON.stringify(this.props.oneTimeCode))
    this.submitChange = this.submitChange.bind(this)
    this.keyboardHeight = new Animated.Value(0)
    this.belowKeyboardHeight = 0
    this.keyboardFullHeight = 200 // guess
  }

  static navigationOptions = {
    header: null
  }

  componentDidMount() {
    this.navigationBar.setLeftNavBarButtons([
      { onPress: this.onBackPress, type: 'back' },
    ])
    this.keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', this.keyboardWillShow.bind(this))
    this.keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', this.keyboardWillHide.bind(this))
  }

  componentWillUnmount( ) {
    this.keyboardWillShowListener.remove( )
    this.keyboardWillHideListener.remove( )
  }

  keyboardWillShow = e => {
    this.keyboardFullHeight = e.endCoordinates.height
    Animated.timing( this.keyboardHeight, { toValue : e.endCoordinates.height, duration : 333 }).start( )
  }

  keyboardWillHide = e => {
    Animated.timing( this.keyboardHeight, { toValue : 0, duration : 333 }).start( )
  }

  onBackPress = () => {
    this.props.clearAuthMode()
  }

  // in web, string from form is coming back as a strange object type

  stringFix = (s) => {
    let sout = s
    if (typeof s !== 'string') { // funky stuff on web there may be a better way to do this, but for now...
      let keys = Object.keys(s)
      sout = ''
      for (let i = 0; i < keys.length; i++) { // keys are "0", "1", etc as strings
        let char = s[i.toString()]
        if (typeof char != 'undefined')
        sout = sout + char
      }
    }
    return sout
  }
  isValid = () => {
    let v = this.state.password.length > 0 && this.state.password == this.state.confirmPassword
    console.info("password = " + JSON.stringify(this.state.password))
    console.info("confirmPassword = " + JSON.stringify(this.state.confirmPassword))
    console.info('change pass isValid = ' + v)
    return v
  }

  change = (values) => {
    Keyboard.dismiss()
    this.props.navigation.dispatch(startSubmit('ChangeForm'))
    this.props.changePassword(values)
  }

  submitChange = () => {
    const state = this.state
    console.info('ChangePasswordScreen submitChange oneTimeCode = ' + state.oneTimeCode)
    console.info('ChangePasswordScreen submitChange password confirm = ' + state.password + ' ' + state.confirmPassword)
    this.props.changePassword(state.oneTimeCode, state.password, state.confirmPassword)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.auth.token)
      this.props.clearAuthMode()
  }

  render() {
    //         <View style={styles.statusBar} />
    const keyboardHgt     = 0 + this.keyboardHeight.__getValue()
    const statusBarHeight = isIPhoneX() ? 30 : 20
    const scrollHeight    = screenHeight - statusBarHeight - keyboardHgt
    const headerFontSize  = isIPhoneX() ? 21 : 17
    const titleBottom     = isIPhoneX() ? 40 : 0
    const headerStyle     = {flexDirection: 'row', justifyContent: 'flex-start', paddingTop: 10, paddingLeft: 10, paddingRight: 10}
    const disabled = !this.isValid()
    const { photo } = this.state
    const { submitting, handleSubmit } = this.props
    return (
      <BaseScreen fullLoading={submitting}>
        <StatusBar translucent barStyle="light-content" />
        <NavigationBar title={I18n.t('login.changePw')} type={'black'} ref={(view) => { if (view) this.navigationBar = view }} />
        <TouchableWithoutFeedback style={{flex: 1, height: '100%'}}>
          <Animated.View keyboardShouldPersistTaps='always' style={{position: 'absolute', width: screenWidth, top: statusBarHeight + 43, bottom: this.keyboardHeight}}>
            <ScrollView keyboardShouldPersistTaps='always' style={{}} contentContainerStyle={{flex: 1, flexDirection: 'column', justifyContent: 'space-between', height: scrollHeight}}>
              <View>
                {!isIPhoneSE && <ProfilePhotoCell >
                  <ProfilePhoto path={photo && photo.path}>
                  </ProfilePhoto>
                </ProfilePhotoCell>}
                <Field name='password'
                  separator
                  autoCorrect={false}
                  onChange={(text) => {
                    this.setState({ password: this.stringFix(text) })
                  }}
                  placeholder={I18n.t("login.pwHelp")}
                  secure={true}
                  title={I18n.t('login.password')}
                  value={this.state.password}
                  component={InputCell}
                />
                <Field name='confirmPassword'
                  separator
                  autoCorrect={false}
                  onChange={(text) => {
                    this.setState({ confirmPassword: this.stringFix(text) })
                  }}
                  placeholder={I18n.t("login.pwHelp")}
                  secure={true}
                  title={I18n.t("login.confirmPw")}
                  value={this.state.confirmPassword}
                  component={InputCell}
                />
                {this.props.auth.error && this.props.auth.error.length > 0 && this.props.auth.modified > this.state.startTime ? <Text style={{paddingLeft: 20, color: 'red'}}>{this.props.auth.error}</Text> : (<Text> </Text>)}
              </View>
              <View style={{ marginVertical: 0 }}>
                <FooterButton
                  disabled={!this.isValid() || submitting}
                  onPress={() => this.submitChange()}
                  style={styles.footerButton}
                  title={I18n.t("login.changePw")}
                />
              </View>
            </ScrollView>
          </Animated.View>
        </TouchableWithoutFeedback>
      </BaseScreen>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth })

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = dispatch => ({
  changePassword: (oneTimeCode,password,changePassword) => dispatch(AuthActions.changePassword(oneTimeCode,password,changePassword)),
  startSubmit: (ChangeForm) => dispatch(startSubmit(ChangeForm))
})

const ChangeForm = reduxForm({
  form: 'ChangeForm',
  validate: validateChangePassword
})(ChangePasswordScreen)

export default connect(mapStateToProps, mapDispatchToProps)(ChangeForm)
